var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgError404(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 58 46",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 46H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4h50a4 4 0 0 1 4 4v38a4 4 0 0 1-4 4z",
    fill: "#35495e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 4v4H0V4a4 4 0 0 1 4-4h50a4 4 0 0 1 4 4z",
    fill: "#3b97d3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 3h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2zm22 0H43a1 1 0 0 0 0 2h11a1 1 0 0 0 0-2z",
    fill: "#2980ba"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    fill: "#ff5364",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 4,
    fill: "#f0c419",
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 4,
    fill: "#65ddb9",
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 31a1 1 0 0 0 2 0v-2h2a1 1 0 0 0 0-2h-2v-2a1 1 0 0 0-2 0v2h-5.211l7.063-11.476a1 1 0 0 0-1.7-1.048l-7.066 11.477A2 2 0 0 0 11.79 29H17zm30-4h-2v-2a1 1 0 0 0-2 0v2h-5.211l7.063-11.476a1 1 0 1 0-1.7-1.048l-7.066 11.477A2 2 0 0 0 37.79 29H43v2a1 1 0 0 0 2 0v-2h2a1 1 0 0 0 0-2zm-19 5h2a4 4 0 0 0 4-4V18a4 4 0 0 0-4-4h-2a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4zm-2-14a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2z",
    fill: "#e64c3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41 37H17a1 1 0 0 0 0 2h24a1 1 0 0 0 0-2zm-9 4h-6a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2z",
    fill: "#c03a2b"
  }))));
}

export default SvgError404;